import React from "react";
import { Alert, Empty } from "antd";
import useClinicalRoleForms, { getIaForm } from "../../../hooks/useClinicalRoleForms";
import ClinicalFormPanel from "./ClinicalFormPanel";
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import { fromApiForm } from "../../../mappers/clinicalForms.mappers";

const ClinicalPractitionerIA = ({ admissionId, admissionType }) => {
  const { forms, loading, error } = useClinicalRoleForms(
    admissionId,
    admissionType
  );

  if (loading) return <LoadingIndicator message="Loading form" />;
  if (error) return <Alert type="error" message={error} showIcon />;

  const iaForm = getIaForm(forms);
  if (!iaForm)
    return (
      <Empty
        style={{ marginTop: 60 }}
        description="No initial assessment form is configured for your role"
      />
    );

  return (
    <ClinicalFormPanel
      form={fromApiForm(iaForm)}
      admissionId={admissionId}
      admissionType={admissionType}
      confirmExit
    />
  );
};

export default ClinicalPractitionerIA;
